export type CharacteristicConsultStatusBadgeTone =
  | 'warning'
  | 'danger'
  | 'success'
  | 'info'
  | 'neutral';

export interface CharacteristicConsultStatusBadge {
  label: string;
  tone: CharacteristicConsultStatusBadgeTone;
  icon: string;
}

export function resolveCharacteristicConsultStatusBadge(
  statusDescription?: string | null,
): CharacteristicConsultStatusBadge {
  const rawLabel = statusDescription?.trim() || '';
  const normalized = rawLabel.toLowerCase();

  if (normalized.includes('rejeitado pela acx') || normalized.includes('rejeitado acx')) {
    return { label: 'Rejeitado ACX', tone: 'danger', icon: 'do_not_disturb_on' };
  }

  if (
    normalized.includes('rejeitado pelo cliente')
    || normalized.includes('rejeitado cliente')
  ) {
    return { label: 'Rejeitado cliente ACX', tone: 'warning', icon: 'cancel' };
  }

  if (
    normalized.includes('rejeitado pela b3')
    || normalized.includes('rejeitado por opera')
    || normalized.includes('rejeitad')
  ) {
    return { label: 'Rejeitado', tone: 'danger', icon: 'do_not_disturb_on' };
  }

  if (normalized.includes('confirmado pelo cliente')) {
    return { label: 'Confirmado pelo Cliente', tone: 'info', icon: 'check_circle' };
  }

  if (
    normalized.includes('registrado na b3')
    || normalized.includes('aprovado')
    || normalized.includes('verificado')
  ) {
    return { label: 'Aprovado', tone: 'success', icon: 'check_circle' };
  }

  if (
    normalized.includes('aguardando validação')
    || normalized.includes('validação da acx')
  ) {
    return {
      label: rawLabel || 'Aguardando validação',
      tone: 'info',
      icon: 'info',
    };
  }

  if (
    normalized.includes('aguardando')
    || normalized.includes('pendente')
    || normalized.includes('confirmação')
  ) {
    return {
      label: rawLabel || 'Pendente',
      tone: 'warning',
      icon: 'schedule',
    };
  }

  return {
    label: rawLabel || '-',
    tone: 'neutral',
    icon: 'info',
  };
}
